module.exports = __webpack_public_path__ + "img/冻雨 (1).1886e22b.png";